import { arrayOf, bool, object, oneOf, shape, string } from "prop-types"
import { MESSAGE_ROLES } from "./constants"

export const MESSAGE = shape({
  id: string.isRequired,
  role: oneOf(Object.values(MESSAGE_ROLES)).isRequired,
  text: string,
  createdAt: string,
  error: object,
  code: string,
  messageType: string,
})

const COLUMN = shape({
  label: string.isRequired,
  format: string.isRequired,
  isPerShare: bool,
})

export const TABLE_ARTIFACT = shape({
  id: string.isRequired,
  records: arrayOf(object).isRequired,
  columns: arrayOf(COLUMN),
  explainSteps: string,
})

export const PLOT_ARTIFACT = shape({
  id: string.isRequired,
  figure: object.isRequired,
  tableArtifactId: string,
})

export const MODEL_METADATA_SHAPE = shape({
  id: string.isRequired,
  name: string.isRequired,
})

const INSTRUMENT_TYPE = oneOf(Object.values(["EXPERIMENT", "BENCHMARK", "SWAP", "ETF", "INDEX", "PORTFOLIO"]))

export const INSTRUMENT_METADATA_SHAPE = shape({
  id: string.isRequired,
  name: string.isRequired,
  type: INSTRUMENT_TYPE.isRequired,
})

export const POSITION_SET_SHAPE = shape({
  id: string.isRequired,
  type: INSTRUMENT_TYPE.isRequired,
})
